import { createContext, createElement, useContext, useState, type ReactNode } from "react";

export const COOKIE_CONSENT_STORAGE_KEY = "nowquantum_cookie_consent";
const STORAGE_KEY = COOKIE_CONSENT_STORAGE_KEY;

/** Event that re-opens the cookie banner so a visitor can change or withdraw consent. */
export const COOKIE_PREFERENCES_EVENT = "nq:open-cookie-preferences";

/** Re-open the cookie consent banner (used by the footer "Cookie Preferences" control). */
export function openCookiePreferences() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(COOKIE_PREFERENCES_EVENT));
  }
}

interface CookieConsentValue {
  consented: boolean;
  setConsented: (v: boolean) => void;
}

const CookieConsentContext = createContext<CookieConsentValue>({
  consented: false,
  setConsented: () => {},
});

export function useCookieConsent() {
  return useContext(CookieConsentContext);
}

export function CookieConsentProvider({ children }: { children: ReactNode }) {
  const [consented, setConsentedState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "accepted";
    } catch {
      return false;
    }
  });

  const setConsented = (v: boolean) => {
    setConsentedState(v);
    try {
      localStorage.setItem(STORAGE_KEY, v ? "accepted" : "rejected");
    } catch { /* noop */ }
  };

  return createElement(
    CookieConsentContext.Provider,
    { value: { consented, setConsented } },
    children
  );
}
